import { BasePalette, CompactPalette, NeutralPalette } from "@Palettes/mui-palette-extension";

export const vrBase: BasePalette = {
  v100: "#FFFFFF",
  v200: "#0E0E11",
};

export const vrNeutralLight: NeutralPalette = {
  v100: "#C2C3CB",
  v200: "#A7A9B4",
  v300: "#7B7D8E",
  v400: "#5E606E",
  v500: "#3F404A",
};

export const vrNeutralDark: NeutralPalette = {
  v100: "#4D4E53",
  v200: "#65676D",
  v300: "#707279",
  v400: "#9EA0A6",
  v500: "#CFD1D3",
};

export const vrSurfaceLight: NeutralPalette = {
  v100: "#F7F7F8",
  v200: "#F1F1F4",
  v300: "#EBECEE",
  v400: "#DCDDE1",
  v500: "#CDCED5",
};

export const vrSurfaceDark: NeutralPalette = {
  v100: "#16171B",
  v200: "#181A1E",
  v300: "#1C1E22",
  v400: "#25272D",
  v500: "#2E3138",
};

export const vrBrandBlue: BasePalette = {
  v100: "#0066FF",
  v200: "#067AFF",
};

export const vrPurple: CompactPalette = {
  v100: "#6900E0",
  v200: "#9335FF",
  v300: "#BE85FF",
};

export const vrGreen: CompactPalette = {
  v100: "#009333",
  v200: "#00E44F",
  v300: "#61FF97",
};

export const vrRed: CompactPalette = {
  v100: "#AD0143",
  v200: "#FC0162",
  v300: "#FE5295",
};

export const vrOrange: CompactPalette = {
  v100: "#A85801",
  v200: "#F88201",
  v300: "#FEAA4D",
};

export const vrYellow: CompactPalette = {
  v100: "#CE9912",
  v200: "#FFD05A",
  v300: "#FFDF8D",
};

export const vrAmber: BasePalette = {
  v100: "#E86637",
  v200: "#EA7348",
};
